module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0009-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev175"
    }
  }, [_vm._v("THE OLD ENGLISH ROAD HORSE.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("IS a strong, vigorous, and active kind, capable of enduring great hardship; its stature rather low, seldom exceeding fifteen hands; the body round and compact, its limbs strong, and its head thick.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Although this breed has of late years been neglected, and almost totally superseded by Horses of another kind, more nearly related to the Race Horse, where the fashion of figure seems to have been preferred to utility, we cannot help congratulating our associated countrymen")]), _c('span', {
    attrs: {
      "href": "#/html/9780226044859_233_not#pg9fn1",
      "id": "rpg9fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*"), _c('sup', [_vm._v("3")])]), _vm._v(" on their spirited exertions towards public improvement, in which nothing of excellency in the various kinds of domestic animals is suffered to escape their vigilance, and this kind is again likely to be brought into notice. A mare of this breed, in the possession of Arthur Mowbray, Esq., of Sherburn, appears to us to possess all the valuable properties attributed to the old Road Horse.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da3ef51c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_12_ch4.vue
// module id = 87
// module chunks = 0